/* wwm-pdp-zoom.js */
/*
  WWM product media zoom, ported from the Kailee P pdp-customizer.
  - Hover zoom (desktop): media-gallery[data-wwm-pz-hover] images scale 1.6x toward the cursor.
  - Gallery modal: click an image in media-gallery[data-wwm-pz-modal] to open a shared native
    <dialog> (top layer, above the sticky header). Its content is cloned from the gallery's
    <template data-wwm-pz-tpl> (snippets/wwm-pdp-zoom-modal.liquid), so it always matches the
    currently rendered variant media. Clicks inside cycle zoom 1.8x -> 3x -> out.
  Listeners live on the .shopify-section, which survives media-gallery.js swapping the gallery
  on variant change.

  QUICK ADD: disabled on purpose. gallery() ignores galleries inside a <dialog> (the quick-add
  modal) and the CSS uses :not(dialog *). To enable it later: drop the closest('dialog') check
  below, remove :not(dialog *) in wwm-pdp-zoom.css, and load this script/CSS on pages that
  open quick add (quick-add.js injects HTML, so the <script> inside the gallery won't run).
*/
(() => {
  if (window.wwmPdpZoom) return;
  window.wwmPdpZoom = true;

  const HOVER = 1.6;
  const ZOOMS = [1, 1.8, 3];
  const desktop = () => matchMedia('(min-width: 750px)').matches;
  const gallery = (el) => {
    const g = el.closest('media-gallery[data-wwm-pz]');
    return g && !g.closest('dialog') ? g : null;
  };
  const clamp = (n) => Math.min(100, Math.max(0, n));
  const setOrigin = (img, x, y) => {
    img.wwmO = [x, y];
    img.style.transformOrigin = `${x}% ${y}%`;
  };
  const origin = (img, box, p) => {
    const r = box.getBoundingClientRect();
    setOrigin(img, ((p.clientX - r.left) / r.width) * 100, ((p.clientY - r.top) / r.height) * 100);
  };

  let dialog, box, track, slides, current = 0, level = 0, zoomed = null, panned = false, down = [0, 0], pan = null, swipe = null, thumbRaf = 0, going = null;

  /* ---------- Hover zoom ---------- */
  const hoverImg = (e) => {
    const c = e.target.closest('.product-media-container--image');
    const g = c && gallery(c);
    return g && g.hasAttribute('data-wwm-pz-hover') ? c.querySelector('.product-media__image') : null;
  };
  const onHover = (e) => {
    const img = desktop() && hoverImg(e);
    if (!img) return;
    if (e.buttons) return (img.style.transform = ''); // slideshow drag in progress
    origin(img, img.parentElement, e);
    img.style.transform = `scale(${HOVER})`;
  };
  const onOut = (e) => {
    const c = e.target.closest('.product-media-container--image');
    if (!c || c.contains(e.relatedTarget)) return;
    const img = c.querySelector('.product-media__image');
    if (img) img.style.transform = img.style.transformOrigin = '';
  };

  /* ---------- Modal zoom ---------- */
  const hiRes = (img) => {
    const src = img.dataset.hi;
    if (!src) return;
    delete img.dataset.hi;
    const hi = new Image();
    hi.onload = () => { img.removeAttribute('srcset'); img.src = src; };
    hi.src = src;
  };
  const setZoom = (slide, lvl, p) => {
    const img = slide.querySelector('img');
    level = lvl;
    zoomed = lvl ? slide : null;
    slide.classList.toggle('is-zoomed', lvl > 0);
    slide.classList.toggle('is-max', lvl === ZOOMS.length - 1);
    if (!lvl) {
      img.wwmO = null;
      return (img.style.transform = img.style.transformOrigin = '');
    }
    if (p) origin(img, slide, p);
    else if (!img.wwmO) setOrigin(img, 50, 50);
    img.style.transform = `scale(${ZOOMS[lvl]})`;
    hiRes(img);
  };
  const resetZoom = () => zoomed && setZoom(zoomed, 0);

  /* ---------- Modal navigation ---------- */
  // Keep the active thumb in view: only moves when it's off screen (12px breathing room), with our own
  // eased rAF scroll so it can't collide with the main track's native smooth scroll.
  const thumbTo = (i, instant) => {
    const t = box.querySelector(`.wwm-pz__thumb[data-wwm-pz-go="${i}"]`);
    const row = t && t.parentElement;
    if (!row) return;
    const r = row.getBoundingClientRect(), b = t.getBoundingClientRect();
    const delta = b.left < r.left ? b.left - r.left - 12 : b.right > r.right ? b.right - r.right + 12 : 0;
    if (!delta) return;
    cancelAnimationFrame(thumbRaf);
    const from = row.scrollLeft, to = Math.max(0, Math.min(row.scrollWidth - row.clientWidth, from + delta));
    if (instant) return (row.scrollLeft = to);
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min(1, (now - t0) / 450);
      row.scrollLeft = from + (to - from) * (1 - (1 - p) ** 3); // ease-out cubic
      if (p < 1) thumbRaf = requestAnimationFrame(step);
    };
    thumbRaf = requestAnimationFrame(step);
  };
  const sync = (i, instant) => {
    current = i;
    box.querySelectorAll('[data-wwm-pz-go]').forEach((el) => el.classList.toggle('is-active', +el.dataset.wwmPzGo === i));
    thumbTo(i, instant);
    slides.forEach((s, si) => s.querySelectorAll('video').forEach((v) => (si === i ? v.play().catch(() => {}) : v.pause())));
  };
  // Thumb/dot/arrow navigation: mark the target right away and ignore the slides passed on the way,
  // so the thumb row doesn't chase every intermediate slide (1s cap in case the scroll is interrupted).
  const go = (i) => {
    i = (i + slides.length) % slides.length;
    resetZoom();
    if (i === Math.round(track.scrollLeft / track.clientWidth)) return; // already there
    sync(i);
    going = { i, until: performance.now() + 1000 };
    track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
  };
  const onScroll = () => {
    const i = Math.round(track.scrollLeft / track.clientWidth);
    if (going && i !== going.i && performance.now() < going.until) return;
    going = null;
    if (i !== current) { resetZoom(); sync(i); }
  };

  const open = (g, i) => {
    const tpl = g.querySelector('template[data-wwm-pz-tpl]');
    if (!tpl) return;
    if (!dialog) build();
    dialog.style.setProperty('--wwm-pz-bg', g.dataset.wwmPzBg || '#fff');
    box.replaceChildren(tpl.content.cloneNode(true));
    track = box.querySelector('[data-wwm-pz-track]');
    slides = [...track.children];
    dialog.showModal();
    document.documentElement.classList.add('wwm-pz-open');
    going = null;
    track.scrollLeft = track.clientWidth * i;
    sync(i, true);
    track.addEventListener('scroll', onScroll, { passive: true });
  };

  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'wwm-pz';
    dialog.setAttribute('aria-label', 'Product media');
    dialog.innerHTML = '<div class="wwm-pz__box"></div>';
    box = dialog.firstChild;
    document.body.append(dialog);

    dialog.addEventListener('close', () => {
      resetZoom();
      cancelAnimationFrame(thumbRaf);
      box.replaceChildren(); // stops videos/iframes
      box.style.transform = box.style.transition = dialog.style.backgroundColor = dialog.style.transition = '';
      document.documentElement.classList.remove('wwm-pz-open');
    });
    dialog.addEventListener('click', (e) => {
      const t = e.target;
      if (t === dialog || t.closest('[data-wwm-pz-close]')) return dialog.close();
      const nav = t.closest('[data-wwm-pz-go]');
      if (nav) return go(+nav.dataset.wwmPzGo);
      const step = t.closest('[data-wwm-pz-step]');
      if (step) return go(current + +step.dataset.wwmPzStep);
      const slide = t.closest('.wwm-pz__slide');
      if (!slide) return;
      const v = slide.classList.contains('wwm-pz__slide--video') && slide.querySelector('video');
      if (v) return v.paused ? v.play().catch(() => {}) : v.pause();
      if (!slide.classList.contains('wwm-pz__slide--image')) return;
      if (panned) return (panned = false);
      const next = zoomed === slide ? (level + 1) % ZOOMS.length : 1;
      resetZoom();
      if (next) setZoom(slide, next, e);
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') go(current + (e.key === 'ArrowRight' ? 1 : -1));
    });
    dialog.addEventListener('mousemove', (e) => {
      if (zoomed && desktop() && e.target.closest('.wwm-pz__slide') === zoomed) origin(zoomed.querySelector('img'), zoomed, e);
    });
    // Mobile pan: drag moves the zoomed image relative to where the finger started (no jump), and a
    // rAF loop eases the origin toward the target each frame (no CSS transition restarts = no stutter).
    const glide = () => {
      const img = zoomed && zoomed.querySelector('img');
      if (!img || !pan || !pan.t) return (pan && (pan.raf = 0));
      const [x, y] = img.wwmO, dx = pan.t[0] - x, dy = pan.t[1] - y;
      if (Math.abs(dx) < 0.05 && Math.abs(dy) < 0.05) return (pan.raf = 0);
      setOrigin(img, x + dx * 0.35, y + dy * 0.35);
      pan.raf = requestAnimationFrame(glide);
    };
    // Mobile swipe-to-close: a vertical drag moves the whole window with the finger (backdrop fades);
    // on release past the threshold it slides off in that direction, otherwise it springs back.
    // Direction locks after 12px and only counts as vertical when clearly steeper than horizontal, so
    // horizontal swipes stay with the image track/thumbs. While zoomed, drags on the image pan instead;
    // drags below it (thumbs/whitespace) still close.
    const drag = (dy, animate) => {
      box.style.transition = animate ? 'transform .25s ease-out' : 'none';
      dialog.style.transition = animate ? 'background-color .25s ease-out' : 'none';
      box.style.transform = dy ? `translateY(${dy}px)` : '';
      dialog.style.backgroundColor = `rgba(0, 0, 0, ${0.72 * (1 - Math.min(1, Math.abs(dy) / innerHeight))})`;
    };
    dialog.addEventListener('touchstart', (e) => {
      panned = false;
      if (pan && pan.raf) cancelAnimationFrame(pan.raf);
      if (e.target.closest('.wwm-pz__thumbs')) cancelAnimationFrame(thumbRaf); // user takes over the row
      if (e.target.closest('[data-wwm-pz-track]')) going = null; // a swipe interrupts button navigation
      const t = e.touches[0];
      const img = zoomed && e.target.closest('.wwm-pz__stage') && zoomed.querySelector('img');
      pan = img && t ? { x: t.clientX, y: t.clientY, o: img.wwmO || [50, 50] } : null;
      swipe = !pan && t && e.touches.length === 1 && !desktop() && !e.target.closest('product-model') ? { x: t.clientX, y: t.clientY, lock: '' } : null;
    }, { passive: true });
    dialog.addEventListener('touchmove', (e) => {
      const t = e.touches[0];
      if (!t) return;
      if (pan && zoomed) {
        e.preventDefault(); // pan the zoomed image instead of swiping slides
        panned = true;
        const r = zoomed.getBoundingClientRect();
        const k = 100 / (ZOOMS[level] - 1); // origin % shift that moves the image 1:1 with the finger
        pan.t = [clamp(pan.o[0] - ((t.clientX - pan.x) / r.width) * k), clamp(pan.o[1] - ((t.clientY - pan.y) / r.height) * k)];
        if (!pan.raf) pan.raf = requestAnimationFrame(glide);
        return;
      }
      if (!swipe || swipe.lock === 'x') return;
      if (!swipe.lock) {
        const dx = t.clientX - swipe.x, dy = t.clientY - swipe.y;
        if (Math.hypot(dx, dy) < 12) return;
        swipe.lock = Math.abs(dy) > Math.abs(dx) * 1.5 ? 'y' : 'x';
        if (swipe.lock === 'x') return;
        Object.assign(swipe, { y: t.clientY, t: e.timeStamp }); // start moving from here (no 12px jump)
      }
      e.preventDefault();
      panned = true;
      drag((swipe.dy = t.clientY - swipe.y));
    }, { passive: false });
    const release = (e) => {
      const s = swipe;
      swipe = null;
      if (!s || s.lock !== 'y') return;
      const dy = s.dy || 0, speed = Math.abs(dy) / Math.max(1, e.timeStamp - s.t);
      if (e.type === 'touchend' && (Math.abs(dy) > Math.max(120, innerHeight * 0.2) || (speed > 0.6 && Math.abs(dy) > 50))) {
        drag(Math.sign(dy) * innerHeight, true);
        setTimeout(() => dialog.close(), 250);
      } else drag(0, true);
    };
    dialog.addEventListener('touchend', release);
    dialog.addEventListener('touchcancel', release);
  };

  /* ---------- Open from gallery ---------- */
  const onClick = (e) => {
    const item = e.target.closest('[data-wwm-pz-index]');
    const g = item && gallery(item);
    if (!g || !g.hasAttribute('data-wwm-pz-modal')) return;
    if (Math.hypot(e.clientX - down[0], e.clientY - down[1]) > 6) return; // was a slideshow drag
    e.preventDefault();
    open(g, +item.dataset.wwmPzIndex);
  };

  const bind = (root) => {
    if (!root || root.wwmPz) return;
    root.wwmPz = true;
    root.addEventListener('pointerdown', (e) => (down = [e.clientX, e.clientY]));
    root.addEventListener('click', onClick);
    root.addEventListener('mousemove', onHover);
    root.addEventListener('mouseout', onOut);
  };
  const init = () => document.querySelectorAll('media-gallery[data-wwm-pz]').forEach((g) => bind(g.closest('.shopify-section') || g.parentElement));

  init();
  document.addEventListener('shopify:section:load', init);
})();
